import React from "react";
import { ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, Grid, FormControlLabel, Checkbox,

} from "@material-ui/core";
import { ExpandMore,  } from "@material-ui/icons";
import { Tag } from "antd";


export const filterPanelData = [
    {
        id:"tranSourcePanel",
        icon:<ExpandMore />,
        heading: "Transaction Source",
        secondHeading:"CARD BANK MERCNANT.WALLET REDMO.WALLET DIRECTPAY.POINT",
        filter: [
            {checked:"card",title:"Card"},
            {checked:"bank",title:"Bank"},
            {checked:"mwallet",title:"Merchant wallet"},
            {checked:"rwallet",title:"Redmo wallet"},
            {checked:"dpoint",title:"Directpay Point"},
        ]
    } ,
    {
        id:"tranChannelPanel",
        icon:<ExpandMore />,
        heading: "Transaction Channel",
        secondHeading:"MCASH EZCASH",
        filter: [
            {checked:"mcash",title:"MCash"},
            {checked:"ezcash",title:"EzCash"}
        ]
    },
    {
        id:"tranStatusPanel",
        icon:<ExpandMore />,
        heading: "Transaction Status",
        secondHeading:"INCOMPLETE PENDING SUCCESS FAILED",
        filter: [
            {checked:"incomplete",title:"INCOMPLETE"},
            {checked:"pending",title:"PENDING"},
            {checked:"success",title:"SUCCESS"},
            {checked:"fail",title:"FAILED"}
        ]
    }   
];


export const FilterPanels = props => {
    return(
        <div>
            {filterPanelData.map(section => (
                <ExpansionPanel key={section.id} expanded={props.states.expanded === section.id} onChange={props.onChange(section.id)}>
                    <ExpansionPanelSummary expandIcon={section.icon}>
                        <Typography className={props.allProps.classes.heading}>{section.heading}</Typography>
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="flex-start"
                        >
                            {section.filter.map(items =>(
                                <Grid item key={items.title} className={props.allProps.classes.secondaryHeading}>                             
                                    {props.states[items.checked] ? <Tag color='blue'>{items.title}</Tag> : null}                             
                                </Grid>
                            ))}
                        </Grid>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="flex-start"
                        >
                            {section.filter.map(items =>(
                                <Grid item key={items.title}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={props.states[items.checked]}
                                                onChange={props.CheckBoxChange(items.checked)}
                                                value={items.title}
                                                color="primary"
                                            />
                                        }
                                        label={items.title}
                                    />
                                </Grid>
                            ))}

                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            ))}    
        </div>   
    );
};
